import { render, staticRenderFns } from "./BookingListStatistic.vue?vue&type=template&id=36d32874&"
import script from "./BookingListStatistic.vue?vue&type=script&lang=js&"
export * from "./BookingListStatistic.vue?vue&type=script&lang=js&"
import style0 from "./BookingListStatistic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports